/* eslint-disable space-before-blocks */
<template>
    <div class="dict-book" id="dict-book">
        <div id="navbar">
            <b-navbar style="background-color: #052640" fixed="top">
                <b-navbar-nav class="book-form-navbar">
                    <multiselect
                        v-model="value"
                        @input="selectDict(value)"
                        :options="directory"
                        :preselect-first="true"
                        label="name"
                        placeholder="Pick a value"
                        :max-height="500">
                    </multiselect>
                </b-navbar-nav>

                <b-button :disabled="!UserRoles.includes('dict_editor')" @click="getPassport" class="button-box" variant="info">Паспорт</b-button>

                <b-navbar-nav class="ml-auto">
                    <b-nav-form>
                        <b-form-input
                            @keydown.enter.prevent
                            size="lg"
                            class="search-nav"
                            placeholder="search"
                            @input="debouncedLoadDirectory"
                            v-model="filter">
                        </b-form-input>
                    </b-nav-form>
                </b-navbar-nav>
            </b-navbar>
        </div>
        <!-- Модалки для добавления/редактирования -->
        <template>
            <!-- Для редактирования -->
            <b-modal
                v-if="!selectedDictIsGuMain"
                @hidden="resetModal"
                id="modal-lg"
                size="md"
                v-model="ShowModal"
                title="Edit">

                <div class="modal-body">
                    <div v-for="col in activeDict.cols" :key="col.key">
                        <b-row>
                            <b-col md="3">
                                <label
                                    v-if="!col.displayOnly && col.key !== 'create_date' && col.key !== 'update_date' && col.key !== 'updateDate' && col.key !== 'action' && col.key !== 'userName'"
                                    for="input-valid">
                                    <template v-if="col.label">
                                        {{ col.label }}
                                    </template>
                                    <template v-else>
                                        {{ col.key }}
                                    </template>
                                </label>
                            </b-col>

                            <b-col md="9">
                                <form class="sign-up" @submit.prevent="checkForm">
                                    <b-form-group
                                        class="book-dict-select-form"
                                        v-if="col.key === 'parent'">
                                        <multiselect
                                            v-model="NewItem[col.key]"
                                            :options="activeDictItems.filter((item) =>
                                         NewItem.id !== item.parent && NewItem.id !== item.id).map((type) => type.id)"
                                            :custom-label="(opt) =>
                                             activeDictItems.find((x) => x.id === opt).name_ru">
                                        </multiselect>
                                    </b-form-group>

                                    <b-form-group class="book-dict-select-form" v-if="col.type === 'select-stat'">
                                        <multiselect
                                            v-model="NewItem[col.key]"
                                            :options="statIndustry"
                                            label="shortname">
                                        </multiselect>
                                    </b-form-group>

                                    <b-form-group class="book-dict-select-form" v-if="col.type === 'select-KatoStat'">
                                        <multiselect
                                            v-model="NewItem[col.key]"
                                            :options="KatoStat"
                                            track-by="id"
                                            label="nameRu"
                                        />
                                    </b-form-group>

                                    <b-form-group class="book-dict-select-form" v-if="col.type === 'select-modules'">
                                        <multiselect
                                            v-model="NewItem[col.key]"
                                            :options="sicModules"
                                            label="nameRu">
                                        </multiselect>
                                    </b-form-group>

                                    <b-form-group class="book-dict-select-form" v-if="col.type === 'select-multiple'">
                                        <multiselect
                                            v-model="NewItem[col.key]"
                                            :options="col.options"
                                            :multiple="true"
                                            :close-on-select="false"
                                            :clear-on-select="false"
                                            :preserve-search="true"
                                        >
                                            <template
                                                slot="selection"
                                                slot-scope="{ isOpen }"
                                            >
                                                <span
                                                    class="multiselect__single"
                                                    v-if="!isOpen"
                                                >
                                                    <template v-for="item of NewItem[col.key]">{{`${item}, `}}</template>
                                                </span>
                                            </template>
                                        </multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        v-if="col.type === 'text'
                                        && col.key !== 'parent'
                                        && col.key !== 'userName'
                                        && col.key !== 'description'
                                        && !col.displayOnly"
                                    >
                                        <b-form-input
                                            v-model.trim="NewItem[col.key]"
                                            type="text"
                                            :formatter="handleFormattedInput[col.key]"
                                            :class="$v.NewItem[col.key].$error ? 'is-invalid' : ''"
                                            :disabled="col.readonly || isTextDisabled(col.key)"
                                            class="input"/>
                                        <p v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].required && $v.NewItem[col.key].required !== undefined"
                                           class="invalid-feedback">
                                            Обязательное поле
                                        </p>
                                        <p v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].numeric && $v.NewItem[col.key].numeric !== undefined"
                                           class="invalid-feedback"> Только цифры
                                        </p>
                                        <p v-if="$v.NewItem[col.key].$dirty && (!$v.NewItem[col.key].minLength || !$v.NewItem[col.key].maxLength) && $v.NewItem[col.key].minLength !== undefined && $v.NewItem[col.key].maxLength !== undefined"
                                           class="invalid-feedback"> Длина {{ col.validation.minLength }} символов
                                        </p>
                                    </b-form-group>

                                    <b-form-group
                                        v-if="col.type === 'texts'"
                                    >
                                        <b-form-tags
                                            input-id="tags-basic"
                                            v-model="NewItem[col.key]"
                                        />
                                        <p v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].required && $v.NewItem[col.key].required !== undefined" class="invalid-feedback">
                                            Обязательное поле
                                        </p>
                                    </b-form-group>

                                    <b-form-group v-if="col.key === 'description'">
                                        <b-form-textarea
                                            v-model="NewItem[col.key]"
                                            type="text"
                                            class="input"
                                            id="textarea-small"
                                            size="sm"
                                        ></b-form-textarea>
                                    </b-form-group>

                                    <b-form-group v-if="col.type === 'asyncSelect'">
                                        <multiselect
                                            v-model="NewItem[col.key]"
                                            :options="asyncSelectOptions[col.key]"
                                            label="label"
                                            :track-by="col.trackBy"
                                            :class="$v.NewItem[col.key].$error ? 'is-invalid' : ''"
                                            :disabled="isSelectDisabled(col.key)"
                                            @search-change="(query) => handleLoadSelects(col.key, query, col.selectsUrl, col.loadOnce)">
                                        </multiselect>
                                        <p v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].required && $v.NewItem[col.key].required !== undefined"
                                           class="invalid-feedback">
                                            Обязательное поле
                                        </p>
                                        <p v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].numeric && $v.NewItem[col.key].numeric !== undefined"
                                           class="invalid-feedback"> Только цифры
                                        </p>
                                        <p v-if="$v.NewItem[col.key].$dirty && (!$v.NewItem[col.key].minLength || !$v.NewItem[col.key].maxLength) && $v.NewItem[col.key].minLength !== undefined && $v.NewItem[col.key].maxLength !== undefined"
                                           class="invalid-feedback"> Длина {{ col.validation.minLength }} символов
                                        </p>
                                    </b-form-group>



                                    <b-form-group v-if="col.type === 'switch'">
                                        <b-form-checkbox v-model="NewItem[col.key]" switch :disabled="col.readonly"/>
                                    </b-form-group>

                                    <b-form-group class="book-dict-select-form" v-if="col.type === 'select-async-multiple'">
                                        <multiselect
                                            v-model="NewItem[col.key]"
                                            :options="asyncSelectOptions[col.key]"
                                            :multiple="true"
                                            :close-on-select="true"
                                            :clear-on-select="true"
                                            :preserve-search="false"
                                            label="label"
                                            track-by="id"
                                            :class="$v.NewItem[col.key].$error ? 'is-invalid' : ''"
                                            @search-change="(query) => handleLoadSelects(col.key, query, col.selectsUrl)"
                                        >
                                            <template
                                                slot="selection"
                                                slot-scope="{ isOpen }"
                                            >
                                                <span
                                                    class="multiselect__single"
                                                    v-if="!isOpen"
                                                >
                                                    <template v-for="item of NewItem[col.key]">{{`${item.shortLabel}, `}}</template>
                                                </span>
                                            </template>
                                        </multiselect>
                                        <p v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].required && $v.NewItem[col.key].required !== undefined"
                                           class="invalid-feedback">
                                            Обязательное поле
                                        </p>
                                        <p v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].numeric && $v.NewItem[col.key].numeric !== undefined"
                                           class="invalid-feedback"> Только цифры
                                        </p>
                                        <p v-if="$v.NewItem[col.key].$dirty && (!$v.NewItem[col.key].minLength || !$v.NewItem[col.key].maxLength) && $v.NewItem[col.key].minLength !== undefined && $v.NewItem[col.key].maxLength !== undefined"
                                           class="invalid-feedback"> Длина {{ col.validation.minLength }} символов
                                        </p>
                                    </b-form-group>

                                    <b-form-group
                                        v-if="col.type === 'date'
                                    &&
                                    col.key !== 'create_date'
                                    &&
                                    col.key !== 'update_date'
                                    &&
                                    col.key !== 'updateDate'">
                                        <b-form-input
                                            :value="millisToDate(NewItem[col.key])"
                                            type="date"
                                            @input="value => handleInputDate(col.key, value)"
                                            :class="$v.NewItem[col.key].$error ? 'is-invalid' : ''"
                                            :disabled="isDateDisabled(col.key)"
                                            class="input"/>
                                        <p v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].required && $v.NewItem[col.key].required !== undefined"
                                           class="invalid-feedback"> Обязательное поле
                                        </p>
                                    </b-form-group>

                                    <b-form-group v-if="
                                        col.type === 'number'
                                        && col.key !== 'parent'
                                        && col.key !== 'minlevel'
                                        && col.key !== 'gr'
                                        && col.key !== 'pgr'
                                        && col.key !== 'abp'
                                        && col.key !== 'prg'
                                        && col.key !== 'ppr'
                                        && !col.displayOnly
                                    ">
                                        <b-form-input
                                            v-model.trim="NewItem[col.key]"
                                            type="number"
                                            class="input"
                                            :class="$v.NewItem[col.key].$error ? 'is-invalid' : ''"
                                            :disabled="isNumberInputDisabled(col.key)"
                                        />
                                        <p v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].required && $v.NewItem[col.key].required !== undefined"
                                           class="invalid-feedback">
                                            Обязательное поле
                                        </p>
                                        <p v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].numeric && $v.NewItem[col.key].numeric !== undefined"
                                           class="invalid-feedback"> Только цифры
                                        </p>
                                        <p v-if="$v.NewItem[col.key].$dirty && (!$v.NewItem[col.key].minLength || !$v.NewItem[col.key].maxLength) && $v.NewItem[col.key].minLength !== undefined && $v.NewItem[col.key].maxLength !== undefined"
                                           class="invalid-feedback"> Длина {{ col.validation.minLength }} символов
                                        </p>
                                    </b-form-group>

                                    <b-form-group v-if="col.key === 'gr'">
                                        <b-form-input
                                            v-model="NewItem[col.key]"
                                            :formatter="handleFormattedInput[col.key]"
                                            type="number"
                                            class="input"
                                            :disabled="!NewItem.type || NewItem.type < 1 || mode === 'EDIT'"
                                        />
                                    </b-form-group>

                                    <b-form-group v-if="col.key === 'pgr'">
                                        <b-form-input
                                            v-model="NewItem[col.key]"
                                            :formatter="handleFormattedInput[col.key]"
                                            type="number"
                                            class="input"
                                            :disabled="!NewItem.type || NewItem.type < 2 || mode === 'EDIT'"
                                        />
                                    </b-form-group>

                                    <b-form-group v-if="col.key === 'abp'">
                                        <b-form-input
                                            v-model="NewItem[col.key]"
                                            :formatter="handleFormattedInput[col.key]"
                                            type="number"
                                            class="input"
                                            :disabled="!NewItem.type || NewItem.type < 3 || mode === 'EDIT'"
                                        />
                                    </b-form-group>

                                    <b-form-group v-if="col.key === 'prg'">
                                        <b-form-input
                                            v-model="NewItem[col.key]"
                                            :formatter="handleFormattedInput[col.key]"
                                            type="number"
                                            class="input"
                                            :disabled="!NewItem.type || NewItem.type < 4 || mode === 'EDIT'"
                                        />
                                    </b-form-group>

                                    <b-form-group v-if="col.key === 'ppr'">
                                        <b-form-input
                                            v-model="NewItem[col.key]"
                                            :formatter="handleFormattedInput[col.key]"
                                            type="number"
                                            class="input"
                                            :disabled="!NewItem.type || NewItem.type < 5 || mode === 'EDIT'"
                                        />
                                    </b-form-group>

                                    <b-form-group v-if="col.key === 'minlevel'">
                                        <b-form-input
                                            v-model="NewItem[col.key]"
                                            :formatter="handleFormattedInput[col.key]"
                                            type="number"
                                            class="input"/>
                                    </b-form-group>

                                    <b-form-group v-if="col.type === 'select' && col.options">
                                        <b-form-select
                                            v-model="NewItem[col.key]"
                                            :options="col.options"
                                            @input="onSelectInput"
                                            :class="$v.NewItem[col.key].$error ? 'is-invalid' : ''"
                                            :disabled="isSelectDisabled(col.key)"
                                        />
                                        <p
                                            v-if="$v.NewItem[col.key].$dirty && !$v.NewItem[col.key].required && $v.NewItem[col.key].required !== undefined"
                                            class="invalid-feedback"
                                        >
                                            Обязательное поле
                                        </p>
                                    </b-form-group>

                                    <b-form-group v-else-if="col.type === 'select'">
                                        <multiselect
                                            class="input"
                                            v-model="NewItem[col.key]"
                                            track-by="value"
                                            label="text"
                                            :options="activeDict.selects"
                                        />
                                    </b-form-group>
                                </form>
                            </b-col>
                        </b-row>
                    </div>
                </div>

                <template #modal-footer>
                    <div class="w-100">
                        <p class="float-left">
                            Редактируемый справочник - {{ activeDict.name }}
                        </p>
                        <b-button
                            type="submit"
                            variant="success"
                            size="tr"
                            class="float-right"
                            @click="checkForm">
                            Сохранить
                        </b-button>
                        <b-button
                            v-if="activeDictSupportsSoftDelete && mode === 'EDIT'"
                            type="button"
                            variant="outline-danger"
                            size="tr"
                            class="float-right mr-2"
                            @click="confirmDeletion">
                            <i class="icon icon-trash"></i>
                            Удалить
                        </b-button>
                    </div>
                </template>
            </b-modal>

            <!-- Для добавления -->
            <b-modal
                v-else
                @hidden="resetModal"
                id="modal-lg"
                size="md"
                v-model="ShowModal"
                title="Редактирование головных гос. учреждений">
                <div class="modal-body">
                    <div>
                        <b-row>
                            <b-col md="3">
                                <label for="input-valid">
                                    Регион
                                </label>
                            </b-col>
                            <b-col md="9">
                                <form class="sign-up">
                                    <b-form-group class="book-dict-select-form">
                                        <multiselect
                                            v-model="selectedModalRegion"
                                            deselect-label="Can't remove this value"
                                            track-by="code"
                                            :custom-label="(opt) => `${opt.code} - ${opt.nameRu}`"
                                            placeholder="Выберите регион"
                                            :options="regions"
                                            @input="setSelectedModalRegionResettingAbp"
                                            :allow-empty="false"
                                        >
                                            <template
                                                slot="singleLabel"
                                                slot-scope="{ option }"
                                            >
                                                <strong>{{ option.code + ' - ' + option.nameRu }}</strong>
                                                </template>
                                        </multiselect>
                                    </b-form-group>
                                </form>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="3">
                                <label for="input-valid">
                                    АБП
                                </label>
                            </b-col>
                            <b-col md="9">
                                <form class="sign-up">
                                    <b-form-group class="book-dict-select-form">
                                        <multiselect
                                            v-model="selectedModalAbp"
                                            track-by="abp"
                                            placeholder="Выберите АБП"
                                            :custom-label="(opt) => `${opt.abp} - ${opt.name_ru}`"
                                            :options="abpModalItems"
                                            :allow-empty="true">
                                            <template
                                                slot="singleLabel"
                                                slot-scope="{ option }">
                                                <strong>{{ option.abp }} - {{ option.name_ru }}</strong>
                                            </template>
                                        </multiselect>
                                    </b-form-group>
                                </form>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="3">
                                <label for="input-valid">
                                    ГУ
                                </label>
                            </b-col>
                            <b-col md="9">
                                <form class="sign-up">
                                    <b-form-group>
                                        <b-form-radio-group
                                            v-model="selectedGuMain"
                                            :options="guModalItems"
                                            text-field="label"
                                            value-field="code"
                                            name="gu-main"
                                        ></b-form-radio-group>
                                    </b-form-group>
                                </form>
                            </b-col>
                        </b-row>
                    </div>
                </div>

                <template #modal-footer>
                    <div class="w-100">
                        <p class="float-left">
                            Редактируемый справочник - {{ activeDict.name }}
                        </p>
                        <b-button
                            type="submit"
                            variant="success"
                            size="tr"
                            class="float-right"
                            @click="checkForm">
                            Сохранить
                        </b-button>
                    </div>
                </template>
            </b-modal>

            <!-- Модальное окно для предпросмотра изменений перед обновлением -->
            <b-modal
                v-model="showUpdatePreviewModal"
                id="update-preview-modal"
                size="md"
                title="Предпросмотр изменений"
                @hidden="resetUpdatePreview"
                :ok-disabled="loadingChanges || !!updatePreviewError || (updatePreviewStats && updatePreviewStats.total === 0)"
                ok-title="ОБНОВИТЬ"
                cancel-title="ОТМЕНИТЬ"
                @ok="confirmUpdate"
                @cancel="cancelUpdate"
                no-close-on-backdrop
                centered
                modal-class="update-preview-modal"
                ok-variant="primary"
                cancel-variant="outline-secondary">
                <div v-if="loadingChanges" class="text-center">
                    <b-spinner></b-spinner>
                    <p>Загрузка изменений...</p>
                </div>
                <div v-else-if="updatePreviewError" class="alert alert-danger">
                    {{ updatePreviewError }}
                </div>
                <div v-else-if="updatePreviewStats">
                    <div v-if="updatePreviewStats.total === 0" class="alert alert-success">
                        <strong>Изменений не обнаружено.</strong> Все данные актуальны. Обновление не требуется.
                    </div>
                    <div v-else>
                        <div class="preview-stats-container">
                            <div class="stat-card stat-card-success">
                                <div class="stat-label">Добавленных записей</div>
                                <div class="stat-value">{{ updatePreviewStats.insertCount }}</div>
                                <!-- <div class="stat-arrow">›</div> -->
                        </div>
                            <div class="stat-card stat-card-danger">
                                <div class="stat-label">Удаленных записей</div>
                                <div class="stat-value">{{ updatePreviewStats.deleteCount }}</div>
                                <!-- <div class="stat-arrow">›</div> -->
                        </div>
                            <div class="stat-card stat-card-warning">
                                <div class="stat-label">Обновленных записей</div>
                                <div class="stat-value">{{ updatePreviewStats.updateCount }}</div>
                                <!-- <div class="stat-arrow">›</div> -->
                    </div>
                </div>
                        <div v-if="integrationDictApiCode" class="stat-card stat-card-download mt-2">
                            <span
                                role="button"
                                class="update-preview-download-link"
                                @click="downloadPreviewChangesExcel"
                            >
                                <span class="update-preview-download-text">Скачать более подробную информацию по изменениям</span>
                                <span class="update-preview-download-suffix">
                                    <img src="/img/svg-icons/excel.svg" alt="Excel" class="update-preview-excel-icon" />
                                    <span class="update-preview-extension">.XLSX</span>
                                </span>
                            </span>
                        </div>
                        <div class="confirmation-message">
                            Вы уверены что хотите применить изменения?
                        </div>
                    </div>
                </div>
                <!-- Компонент с деталями обновления закомментирован! -->
                <!-- <transition name="slide-fade">
                    <update-dict-data v-if="showUpdateDetails"></update-dict-data>
                </transition> -->
                <template #modal-footer="{ ok, cancel }">
                    <div class="update-preview-footer">
                        <b-button
                            variant="primary"
                            :disabled="loadingChanges || !!updatePreviewError || (updatePreviewStats && updatePreviewStats.total === 0)"
                            @click="ok()">
                            ОБНОВИТЬ
                        </b-button>
                        <b-button variant="outline-secondary" @click="cancel()">
                            ОТМЕНИТЬ
                        </b-button>
                    </div>
                </template>
            </b-modal>

            <!-- Модальное окно для деталей изменений в журнале загрузок -->
            <b-modal
                v-model="showLogDetailsModal"
                id="log-details-modal"
                size="xl"
                title="Детализация изменений"
                @hidden="resetLogDetails"
                scrollable>
                <div v-if="logDetailsLoading" class="text-center">
                    <b-spinner></b-spinner>
                    <p>Загрузка деталей...</p>
                </div>
                <div v-else-if="logDetailsData">
                    <div v-if="logDetailsData.detailsSummary" class="mb-3">
                        <h6>Сводка изменений:</h6>
                        <ul>
                            <li><strong>Всего изменений:</strong> {{ logDetailsData.detailsSummary.totalCount || 0 }}</li>
                            <li><strong>Добавлено:</strong> <span class="text-success">{{ logDetailsData.detailsSummary.insertCount || 0 }}</span></li>
                            <li><strong>Обновлено:</strong> <span class="text-warning">{{ logDetailsData.detailsSummary.updateCount || 0 }}</span></li>
                            <li><strong>Удалено:</strong> <span class="text-danger">{{ logDetailsData.detailsSummary.deleteCount || 0 }}</span></li>
                        </ul>
                    </div>

                    <div v-if="logDetailsData.changesContent && logDetailsData.changesContent.length > 0">
                        <h6>Детали изменений:</h6>
                        <div v-if="logDetailsData.truncated" class="alert alert-info mb-2">
                            <small>Показаны первые {{ logDetailsData.changesContent.length }} из {{ logDetailsData.totalChangesCount }} изменений</small>
                        </div>
                        <b-table
                            striped
                            bordered
                            small
                            :items="formatChangesContent(logDetailsData.changesContent)"
                            :fields="changesDetailsFields"
                            responsive>
                            <template #cell(changeType)="data">
                                <span :class="getChangeTypeClass(data.value)">
                                    {{ formatChangeType(data.value) }}
                                </span>
                            </template>
                            <template #cell(field)="data">
                                <strong>{{ data.value }}</strong>
                            </template>
                            <template #cell(oldValue)="data">
                                <span class="text-muted">{{ formatChangeValue(data.value) }}</span>
                            </template>
                            <template #cell(newValue)="data">
                                <span class="text-primary">{{ formatChangeValue(data.value) }}</span>
                            </template>
                        </b-table>
                    </div>
                    <div v-else-if="logDetailsData.error" class="alert alert-danger">
                        <strong>Ошибка:</strong> {{ logDetailsData.error }}
                    </div>
                    <div v-else class="alert alert-info">
                        Детализация изменений недоступна
                    </div>
                </div>
                <update-dict-data v-if="integrationDictApiCode" :api-dict-code="integrationDictApiCode"></update-dict-data>
            </b-modal>
        </template>
        <enstru-form v-if="value.tableName == 'enstru'" year="2011"></enstru-form>
        <b-card class="table-container book-dict-table">
            <template #header>
                <b-form-row>
                    <div style="width: 100%;">
                        <multiselect
                            v-if="selectedDictIsGuMain"
                            v-model="selectedRegion"
                            deselect-label="Can't remove this value"
                            track-by="code"
                            :custom-label="(opt) => `${opt.code} - ${opt.nameRu}`"
                            placeholder="Выберите регион"
                            :options="regions"
                            :allow-empty="false"
                            @input="setSelectedRegionResettingAbp"
                        >
                            <template
                                slot="singleLabel"
                                slot-scope="{ option }"
                            >
                                <strong>{{ option.code + ' - ' + option.nameRu }}</strong>
                            </template>
                        </multiselect>
                        <multiselect
                            v-if="selectedDictIsGuMain"
                            v-model="selectedAbp"
                            track-by="abp"
                            placeholder="Выберите АБП"
                            :custom-label="(opt) => `${opt.abp} - ${opt.name_ru}`"
                            :options="abpItems"
                            :allow-empty="true"
                            @input="setSelectedAbp">
                            <template
                                slot="singleLabel"
                                slot-scope="{ option }">
                            <strong>{{ option.abp }} - {{ option.name_ru }}</strong>
                        </template>
                        </multiselect>
                        <multiselect
                            v-if="selectedDictIsGuMain"
                            v-model="selectedFilterOption"
                            :options="filterOptions"
                            :allow-empty="false">
                        </multiselect>

                        <div style="display: flex; align-items: center; gap: 10px; width: 100%;">
                            <div v-if="shouldShowTabs" style="display: flex; align-items: center; gap: 0;">
                                <div
                                    class="tab-button"
                                    :class="{ 'tab-active': activeTab === 'directories' }"
                                    @click="activeTab = 'directories'"
                                    :style="activeTab === 'directories' ? 'cursor: pointer; padding: 8px 16px; background-color: #EEF1F8; border: 1px solid #dee2e6; border-right: none; border-radius: 4px 0 0 4px;' : 'cursor: pointer; padding: 8px 16px; background-color: #ffffff; border: 1px solid #dee2e6; border-right: none; border-radius: 4px 0 0 4px;'">
                                    СПРАВОЧНИКИ
                                </div>
                                <div
                                    class="tab-button"
                                    :class="{ 'tab-active': activeTab === 'upload-log' }"
                                    @click="activeTab = 'upload-log'"
                                    :style="activeTab === 'upload-log' ? 'cursor: pointer; padding: 8px 16px; background-color: #EEF1F8; border: 1px solid #dee2e6; border-radius: 0 4px 4px 0;' : 'cursor: pointer; padding: 8px 16px; background-color: #ffffff; border: 1px solid #dee2e6; border-radius: 0 4px 4px 0;'">
                                    ЖУРНАЛ ЗАГРУЗОК
                                </div>
                            </div>

                            <div v-if="shouldShowTabs" style="flex: 1 1 auto;"></div>

                            <div
                                v-if="!shouldShowTabs || activeTab === 'directories'"
                                :style="{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    marginLeft: shouldShowTabs ? 'auto' : null
                                }"
                            >
                                <b-button
                                    v-if="!selectedDictIsGuMain && isCertainUser"
                                    @click="addItem"
                                    :disabled="isNonAddable"
                                    variant="success">
                                    Добавить
                                </b-button>

                                <b-button
                                    v-if="isCertainUser"
                                    @click="editItem"
                                    variant="primary">
                                    Изменить
                                </b-button>

                                <b-dropdown text="Колонки" variant="secondary">
                                    <b-form-checkbox
                                        v-for="option in tableFields"
                                        :key="option.key"
                                        v-model="select"
                                        @change="toggleAll(option)">
                                        {{ option.key }}
                                    </b-form-checkbox>
                                </b-dropdown>

                                <b-button
                                    v-if="activeDict.updatable && integrationDictApiCode"
                                    @click="updateDict"
                                    variant="secondary"
                                    v-b-tooltip.hover
                                    title="Обновить">
                                    <i class="icon icon-refresh"></i>
                                </b-button>

                                <b-form-checkbox v-if="activeDict.hasParent" switch size="lg"
                                                 v-b-tooltip.hover title="Иерархический вид"
                                                 v-model="isHidden"
                                                 switches
                                                 stacked
                                                 name="checkbox-1"
                                                 value="is-hidden"
                                                 unchecked-value="showAll"
                                                 @change="turnOnModeTree()">
                                </b-form-checkbox>
                            </div>
                        </div>
                    </div>

                    <div v-if="activeDictSupportsSoftDelete" style="display: flex; margin-left: auto; align-items: center;">
                        <span>Исключить удаленные</span>
                        <b-form-checkbox v-model="excludeDeleted" switch style="margin-left: 1rem;" />
                    </div>
                </b-form-row>
            </template>

            <template v-if="!shouldShowTabs || activeTab === 'directories'">
                <div class="table-container">
                    <b-overlay
                        :show="loading"
                        rounded="sm"
                        :opacity="0.75"
                        spinner-variant="primary"
                        spinner-type="grow"
                        spinner-small
                    >
                        <b-table
                            id="my-table"
                            responsive="true"
                            bordered
                            head-variant="light"
                            sticky-header
                            no-border-collapse
                            striped
                            :sort-by.sync="sortBy"
                            :no-local-sorting="noLocalSorting"
                            thead-class="bold_header"
                            selected-variant="danger"
                            selectable
                            select-mode="single"
                            @row-selected="onRowSelected"
                            :fields="tableFields"
                            :items="activeDictItems"
                            small
                            :tbody-tr-class="rowClass"
                        >
                            <template #cell(selected)="{ rowSelected }">
                                <template v-if="rowSelected">
                                    <span aria-hidden="true">&check;</span>
                                </template>

                                <template v-else>
                                    <span aria-hidden="true">&nbsp;</span>
                                </template>
                            </template>

                            <template #cell(action)="data">
                                <b-button
                                    v-if="activeDictItems.find((x) => x.parent === data.item.id) && isHidden === 'is-hidden'"
                                    @click="openChild(data.item)"
                                    class="m-0">
                                    <i class="icon icon-keyboard icon-rotate-90"> </i>
                                </b-button>
                            </template>

                            <template #cell(parent)="data">
                                {{ getDictItemById(data.item.parent) }}
                            </template>

                            <template #cell(parentId)="data">
                                {{ getDictItemById(data.item.parentId) }}
                            </template>

                            <template class="tr" #cell(create_date)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.createDate) }}
                                </div>
                            </template>

                            <template class="tr" #cell(createDate)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.createDate) }}
                                </div>
                            </template>

                            <template class="tr" #cell(begDate)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.begDate) }}
                                </div>
                            </template>

                            <template class="tr" #cell(beginDate)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.beginDate) }}
                                </div>
                            </template>

                            <template class="tr" #cell(endDate)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.endDate) }}
                                </div>
                            </template>

                            <template #cell(update_date)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.updateDate) }}
                                </div>
                            </template>

                            <template #cell(beg_date)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.beg_date) }}
                                </div>
                            </template>

                            <template #cell(begin_date)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.begin_date) }}
                                </div>
                            </template>

                            <template #cell(end_date)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.end_date) }}
                                </div>
                            </template>

                            <template #cell(startdate)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.startDate) }}
                                </div>
                            </template>

                            <template #cell(updateDate)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.updateDate) }}
                                </div>
                            </template>

                            <template #cell(statIndustry)="data">
                                <div class="tr">
                                    {{ data.item.statIndustry ? data.item.statIndustry.shortname : ""}}
                                </div>
                            </template>

                            <template v-if="activeDict === 'kato'" #cell(statKato)="data">
                                <div class="tr">
                                    {{ data.item.statKato ? data.item.statKato.name_ru : "" }}
                                </div>
                            </template>
                            <template v-else #cell(statKato)="data">
                                <div class="tr">
                                    {{ data.item.statKato ? data.item.statKato.code : "" }}
                                </div>
                            </template>

                            <template #cell(appCodes)="data">
                                <div class="tr">
                                    {{ data.item.appCodesLabels ? data.item.appCodesLabels : data.item.appCodes }}
                                </div>
                            </template>

                            <template #cell(startDate)="data">
                                <div class="tr">
                                    {{ millisToDate(data.item.startDate) }}
                                </div>
                            </template>

                            <template v-if="activeDict.tableName !== 'appointment'" #cell(module)="data">
                                <div class="tr">
                                    {{data.item.module ? data.item.module.nameRu : ""}}
                                </div>
                            </template>
                            <template v-else #cell(module)="data">
                                <div class="tr">
                                    {{ data.item.module.label }}
                                </div>
                            </template>

                            <template v-if="activeDict.tableName === 'appointment'" #cell(operation)="data">
                                <div v-if="data.item.operation" class="tr">
                                    {{ data.item.operation.label }}
                                </div>
                            </template>

                            <template #cell(orgType)="data">
                                <div class="tr">
                                    {{ data.item.orgType.code }} - {{ data.item.orgType.nameRu }}
                                </div>
                            </template>

                            <template #cell(budgetLevelId)="data">
                                <div class="tr">
                                    <div v-if="data.item.budgetLevelId && activeDict.tableName !== 'ebk_func_types'">
                                        {{ data.item.budgetLevelId.id }} - {{ data.item.budgetLevelId.nameRu }}
                                    </div>
                                    <div v-else>
                                        {{ data.item.budgetLevelId }}
                                    </div>
                                </div>
                            </template>
                        </b-table>
                    </b-overlay>
                </div>
            </template>

            <template v-if="shouldShowTabs && activeTab === 'upload-log'">
                <dict-jurnal :selected-dict="selectedDict"></dict-jurnal>
<!--                <div class="table-container">-->
<!--                    <b-overlay-->
<!--                        :show="uploadLogLoading"-->
<!--                        rounded="sm"-->
<!--                        :opacity="0.75"-->
<!--                        spinner-variant="primary"-->
<!--                        spinner-type="grow"-->
<!--                        spinner-small-->
<!--                    >-->
<!--                        <b-table-->
<!--                            id="upload-log-table"-->
<!--                            responsive="true"-->
<!--                            bordered-->
<!--                            head-variant="light"-->
<!--                            sticky-header-->
<!--                            no-border-collapse-->
<!--                            striped-->
<!--                            :sort-by.sync="uploadLogSortBy"-->
<!--                            :sort-desc.sync="uploadLogSortDesc"-->
<!--                            thead-class="bold_header"-->
<!--                            :fields="uploadLogFields"-->
<!--                            :items="uploadLogItems"-->
<!--                            small-->
<!--                            :per-page="uploadLogPerPage"-->
<!--                            :current-page="uploadLogCurrentPage"-->
<!--                            @page-change="handleUploadLogPageChange"-->
<!--                        >-->
<!--                            <template #cell(details)="data">-->
<!--                                <div style="text-align: left;">-->
<!--                                    <div v-if="data.item.detailsSummary">-->
<!--                                        <div style="margin-bottom: 5px;">-->
<!--                                            <span v-if="data.item.detailsSummary.insertCount > 0" class="text-success" style="margin-right: 10px;">-->
<!--                                                Добавлено: {{ data.item.detailsSummary.insertCount }}-->
<!--                                            </span>-->
<!--                                            <span v-if="data.item.detailsSummary.updateCount > 0" class="text-warning" style="margin-right: 10px;">-->
<!--                                                Обновлено: {{ data.item.detailsSummary.updateCount }}-->
<!--                                            </span>-->
<!--                                            <span v-if="data.item.detailsSummary.deleteCount > 0" class="text-danger" style="margin-right: 10px;">-->
<!--                                                Удалено: {{ data.item.detailsSummary.deleteCount }}-->
<!--                                            </span>-->
<!--                                        </div>-->
<!--                                        <b-button -->
<!--                                            v-if="data.item.hasChangesContent"-->
<!--                                            size="sm" -->
<!--                                            variant="outline-info"-->
<!--                                            @click="showLogDetails(data.item)">-->
<!--                                            Подробнее-->
<!--                                        </b-button>-->
<!--                                    </div>-->
<!--                                    <div v-else style="white-space: pre-line;">-->
<!--                                        {{ data.item.details }}-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </template>-->

<!--                            <template #cell(loadStatus)="data">-->
<!--                                <div :style="getStatusStyle(data.item.loadStatus)">-->
<!--                                    {{ data.item.loadStatus }}-->
<!--                                </div>-->
<!--                            </template>-->
<!--                        </b-table>-->
<!--                    </b-overlay>-->
<!--                </div>-->
            </template>

            <template #footer>
                <b-pagination
                    v-show="activeTab === 'directories' && isHidden !== 'is-hidden' && !selectedDictIsGuMain"
                    aria-controls="my-table"
                    size="sm"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    @input="handlePageChange"
                ></b-pagination>

                <b-pagination
                    v-show="activeTab === 'upload-log' && uploadLogTotalRows > 0"
                    aria-controls="upload-log-table"
                    size="sm"
                    v-model="uploadLogCurrentPage"
                    :total-rows="uploadLogTotalRows"
                    :per-page="uploadLogPerPage"
                    @input="handleUploadLogPageChange"
                ></b-pagination>
            </template>
        </b-card>

    </div>
</template>


<script>
import store from '@/services/store';
import {validationMixin} from 'vuelidate';
import {required, helpers, minLength, maxLength, numeric} from 'vuelidate/lib/validators';
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css';
import Multiselect from 'vue-multiselect';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import dicts from './dicts.json';
import {Ax} from '@/utils';
import { debounce, cloneDeep } from 'lodash'
import EnstruForm from './enstru-form.vue'
import DictJurnal from './dict-jurnal.vue';
import UpdateDictData from './update-dict-data.vue';

const alpha = helpers.regex('alpha', /^[A-Za-z0-9-,.()_{/} ]*$/);
const Cyrillic = helpers.regex('Cyrillic', /^[А-Яа-я0-9-,.()_{/}) ]*$/);
const dictUpdateIncludeUsername = ['gu_kgkp']
const nonAddableDicts = ['enstru']
export default {
    name: 'book-dict',
    components: {multiselect: Multiselect, EnstruForm, DictJurnal, UpdateDictData},

    computed: {
        rows() {
            return this.itemCount//this.activeDictItems.length;
        },

        selectedDictIsGuMain() {
            return this.selectedDict === 'gu_main'
        },

        isNonAddable() {
            return nonAddableDicts.includes(this.selectedDict)
        },

        // Признак того, что у справочника есть soft-delete (в cols описана колонка isDeleted)
        activeDictSupportsSoftDelete() {
            return Boolean(this.activeDict.cols) && this.activeDict.cols.some(col => col.key === 'isDeleted')
        },

        // Certain user only in prod/release. In test allows for everyone
        isCertainUser() {
            const isTestEnviroment = this.server === 'MASTER'
            if (isTestEnviroment) {
                return true
            }
            return ['98862e7d-4719-4aee-bf6f-6d7ac9863b59', '7d306036-6f0c-4132-8e0c-d8d9ec07abbb',
                'ec38d0e9-9724-4e8b-8279-eb78074bb0e1', 'd54ea319-8eb4-4b9c-9bb9-c487608874d1',
                '458bbb85-320b-42fe-8a9d-879d8b6d6c63', 'd905d8a0-b873-4940-a9f6-7c229a3fd70e',
                '6578f204-759a-4982-80ad-e98114839f0c',
                '08537a6f-95a1-419c-95f3-f430ec51eaa9', '7224db75-7faf-4a6b-920f-c5e1d0c0c6f3'].includes(this.userSub);
            // return this.userSub === '98862e7d-4719-4aee-bf6f-6d7ac9863b59'
            // Две последние для almaty-release.csi.kz
        },

        // Проверка: должны ли отображаться вкладки СПРАВОЧНИКИ и ЖУРНАЛ ЗАГРУЗОК
        shouldShowTabs() {
            const dictsWithTabs = ['gu', 'dict_ebk_doh', 'dict_budget_regions', 'dict_ebk_ek', 'ebk_func_types'];
            return dictsWithTabs.includes(this.selectedDict);
        },

        /** Код справочника для /api/integration/dict/* (предпросмотр, журнал, экспорт) */
        integrationDictApiCode() {
            const map = {
                gu: 'GU',
                dict_ebk_ek: 'EKR',
                dict_budget_regions: 'TPK',
                dict_ebk_doh: 'KPB',
                ebk_func_types: 'FKR'
            };
            return map[this.selectedDict] || null;
        }
    },

    watch: {
        currentPage() {
            this.loadDirectory()
        },

        excludeDeleted() {
            this.currentPage = 1
            this.loadDirectory()
        },

        ShowModal(value) {
            if (value) {
                this.selectedModalRegion = this.selectedRegion
                if (this.selectedAbp !== null && this.selectedAbp.abp !== '' && this.selectedAbp.abp !== null) {
                    this.selectedModalAbp = this.selectedAbp
                    this.guModalItems = this.allDictItems
                }
            }
        },

        selectedModalRegion(value) {
            this.guModalItems = []
            if (value !== null)
                this.loadAbpItems(value.code)
        },

        selectedModalAbp(value) {
            if (value !== null && value.abp !== '' && value.abp !== null)
                this.loadGuMainDirectory(this.selectedModalRegion.code, value.abp)
            else
                this.guModalItems = []
        },

        selectedFilterOption(value) {
            this.filterGuMainItemsBy(value)
        },

        activeTab(newVal) {
            if (newVal === 'upload-log') {
                // this.loadUploadLog()
            }
        },

        selectedDict(newVal) {
            // Если выбран справочник без вкладок, автоматически переключаемся на вкладку "Справочники"
            if (!this.shouldShowTabs && this.activeTab === 'upload-log') {
                this.activeTab = 'directories';
            }
            if (this.activeTab === 'upload-log') {
                // this.loadUploadLog()
            }
        },
    },

    mixins: [validationMixin],

    async mounted() {
        await this.setServerInfo()
        await this.loadDictItems()
        await this.loadRegions()
    },

    data() {
        return {
            UserRoles: store.state.user.roles,
            userSub: store.state.user.sub,
            server: null,
            value: '',
            activeDict: {},
            tableFields: [],
            activeDictItems: [],
            allDictItems: [],
            ShowModal: false,
            NewItem: {},
            filterParams: {},
            perPage: 50,
            currentPage: 1,
            directory: dicts,
            filter: '',
            excludeDeleted: true,
            passport: [],
            KatoStat: [],
            statIndustry: [],
            sicModules: [],
            EditPass: false,
            isHidden: 'showAll',
            textRight: '',
            sortBy: '',
            noLocalSorting: false,
            filterOn: null,
            selectedDict: '',
            loading: false,
            itemCount: 0,
            regions: [],
            abpItems: [],
            abpModalItems: [],
            selectedRegion: null,
            selectedAbp: null,
            selectedModalRegion: null,
            selectedModalAbp: null,
            guModalItems: [],
            selectedGuMain: null,
            filterOptions: ['Все записи', 'Головные', 'Без головного ГУ'],
            selectedFilterOption: 'Все записи',
            asyncSelectOptions: {},
            handleFormattedInput: {},
            mode: null, // 'ADD', 'EDIT'
            activeTab: 'directories', // 'directories' or 'upload-log'
            uploadLogItems: [],
            changesDetailsFields: [
                { key: 'changeType', label: 'Тип изменения', sortable: true },
                { key: 'code', label: 'Код записи', sortable: true },
                { key: 'field', label: 'Поле', sortable: true },
                { key: 'oldValue', label: 'Старое значение', sortable: false },
                { key: 'newValue', label: 'Новое значение', sortable: false }
            ],
            uploadLogLoading: false,
            uploadLogSortBy: 'loadDateTime',
            uploadLogSortDesc: true,
            uploadLogCurrentPage: 1,
            uploadLogPerPage: 20,
            uploadLogTotalRows: 0,
            // Переменные для предпросмотра изменений
            showUpdatePreviewModal: false,
            loadingChanges: false,
            updatePreviewError: null,
            updatePreviewStats: null,
            pendingChanges: null,
            showUpdateDetails: false,
            // Переменные для модального окна деталей журнала
            showLogDetailsModal: false,
            logDetailsData: null,
            logDetailsLoading: false
        };
    },
    validations() {
        const NewItem = {}
        const formatter = {}
        for (const key in this.activeDict.cols) {
            if (Object.hasOwnProperty.call(this.activeDict.cols, key)) {
                const element = this.activeDict.cols[key];
                NewItem[element.key] = {}
                formatter[element.key] = value => value
                if (element.validation) {
                    if (element.validation.required) {
                        NewItem[element.key].required = required
                    }
                    if (element.validation.minLength) {
                        NewItem[element.key].minLength = minLength(element.validation.minLength)
                    }
                    if (element.validation.maxLength) {
                        const maximumLength = element.validation.maxLength
                        NewItem[element.key].maxLength = maxLength(maximumLength)
                        const copiedPreviousFunc = formatter[element.key].bind({});
                        formatter[element.key] = (value) => {
                            value += ''
                            value = value.length > maximumLength ? value.substring(0, maximumLength) : value
                            return copiedPreviousFunc(value)
                        }
                    }
                    if (element.validation.numeric) {
                        NewItem[element.key].numeric = numeric
                        const copiedPreviousFunc = formatter[element.key].bind({});
                        formatter[element.key] = value => {
                            value += ''
                            value = value.replace(/\D/g, "");
                            return copiedPreviousFunc(value)
                        }
                    }
                }
            }
        }
        this.handleFormattedInput = formatter
        return {
            NewItem
        }
    },
    methods: {
        onSelectInput(paramType) {
            if (this.activeDict.tableName === 'ebk_func_types') {
                const type = paramType || 0
                if (type <= 4) {
                    if (this.NewItem.ppr != null) this.NewItem.ppr = null
                }
                if (type <= 3) {
                    if (this.NewItem.prg != null) this.NewItem.prg = null
                }
                if (type <= 2) {
                    if (this.NewItem.abp != null) this.NewItem.abp = null
                }
                if (type <= 1) {
                    if (this.NewItem.pgr != null) this.NewItem.pgr = null
                }
                if (type <= 0) {
                    if (this.NewItem.gr != null) this.NewItem.gr = null
                }

                if (type == null || type === 1 || type === 2 || type === 4 || type === 5) {
                    this.NewItem.budgetLevelId = null
                }
                if (type == null || type === 1 || type === 2 || type === 3 || type === 5) {
                    this.NewItem.developType = null
                }
            }
        },

        isNumberInputDisabled(key) {
            if (this.activeDict.tableName === 'ebk_func_types') {
                if (this.NewItem.type === 1 || this.NewItem.type === 2) {
                    return key === 'budgetLevelId' || key === 'developType'
                } else if (this.NewItem.type === 3) {
                    return key === 'developType'
                } else if (this.NewItem.type === 4) {
                    return key === 'budgetLevelId'
                }  else if (this.NewItem.type === 5) {
                    return key === 'budgetLevelId' || key === 'developType'
                }

                return true
            }

            return key === 'id' && this.mode === 'EDIT'
        },

        isSelectDisabled(key) {
            if (this.activeDict.tableName === 'ebk_func_types') {
                if (key === 'type') {
                    return false
                }

                if (this.NewItem.type === 1 || this.NewItem.type === 2) {
                    return key === 'budgetLevelId' || key === 'developType'
                } else if (this.NewItem.type === 3) {
                    return key === 'developType'
                } else if (this.NewItem.type === 4) {
                    return key === 'budgetLevelId'
                }  else if (this.NewItem.type === 5) {
                    return key === 'budgetLevelId' || key === 'developType'
                }

                return true
            }

            return false
        },

        isDateDisabled(key) {
            if (this.activeDict.tableName === 'ebk_func_types') {
                if (key === 'begDate' || key === 'endDate') {
                    return this.NewItem.type == null
                }
            }

            return false
        },

        isTextDisabled(key) {
            if (this.activeDict.tableName === 'ebk_func_types') {
                return this.NewItem.type == null
            }

            return false
        },

        async setServerInfo() {
            try {
                const response = await fetch('/api/dict/get-budget-obl?obl=' + store.state._instanceCode)
                if (response.ok) {
                    const json = await response.json()
                    this.server = json.server
                } else {
                    this.makeToast('danger', 'get-budget-obl', `${response.status} - ${response.statusText}`);
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса get-budget-obl', error.toString());
            }
        },

        resetModeTree() {
            this.noLocalSorting = false;
            this.isHidden = 'showAll';
            if (this.isHidden === 'is-hidden') {
                this.perPage = 'none';
            } else {
                this.perPage = 50;
            }
        },

        turnOnModeTree() {
            this.noLocalSorting = !this.noLocalSorting;
            this.sortBy = null;
            if (this.isHidden === 'is-hidden') {
                this.perPage = 'none';
            } else {
                this.perPage = 50;
            }
        },

        onFiltered(filteredItems) {
            this.totalRows =  [...filteredItems.length];
            this.currentPage = 1;
            this.items.count = [...filteredItems.length];
        },

        openChild(item) {
            this.NewItem = !this.NewItem;
            this.activeDictItems.forEach((data) => {
                if (item.id === data.parent) {
                    data.open = !data.open;
                }
                if (data.layer > 1 && data.open === false) {
                    this.activeDictItems.forEach((item) => {
                        if (data.id === item.parent) {
                            item.open = false;
                        }
                    });
                }
            });
        },

        rowClass(item, type) {
            this.textRight = ' text-right';
            this.textLeft = 'text-left';
            if (!item || type !== 'row') {
                return;
            }
            if (!item.open) {
                return this.isHidden;
            }
            if (item.layer % 2 === 0 && this.isHidden === 'is-hidden') {
                return this.textRight;
            }
            if (item.layer !== 0 && this.isHidden === 'is-hidden') {
                return this.textLeft + ' table-primary';
            }
        },

        toggleAll(option) {
            if (option.thClass === 'true' && option.tdClass === 'true') {
                option.thClass = 'd-none';
                option.tdClass = 'd-none';
                this.select = true;
            } else if (option.thClass === 'd-none' && option.tdClass === 'd-none') {
                option.thClass = 'true';
                option.tdClass = 'true';
                this.select = true;
            }
        },

        checkEdit() {
            this.EditPass = this.activeDict.url === '/api/stat-dict/';
        },

        resetModal() {
            this.NewItem = {};
        },

        getPassport() {
            this.NewItem = this.passport.find(
                (x) => x.code === this.activeDict.tableName
            );
            if (this.NewItem) {
                this.ShowModal = true;
            } else {
                this.makeToast('Паспорт отсутствует', 'Ошибка !');
            }
        },

        async onRowSelected(row) {
            this.NewItem = {}
            this.NewItem = this.convertChosenRow(row)
            await this.loadAsyncSelectChoice()
        },

        convertChosenRow(row) {
            const copy = JSON.parse(JSON.stringify(row[0]))
            // TODO: make generic for all dicts
            if (this.selectedDict === 'gu') {
                copy.orgAttribute = this.activeDict.selects.find(it => it.value === copy.orgAttribute)
            }
            if (this.selectedDict === 'dict_budget_regions') {
                copy.budgetLevel = this.activeDict.selects.find(it => it.value === copy.budgetLevel)
            }
            this.activeDict.cols.forEach(col => {
                if (col.type === 'select' && col.options) {
                    let option = col.options.find(it => {
                        let value = it
                        if (it.value) {
                            value = it.value
                        }
                        return value === copy[col.key]
                    }) ?? null

                    if (this.selectedDict === 'ebk_func_types' && col.key === 'type') {
                        if (option.value != null) {
                            option = option.value
                        }
                    }
                    copy[col.key] = option
                }
            })
            return copy
        },

        handleInputDate(key, value) {
            if (!value.startsWith('0')) // if allow year to start with 0, would reset input
                this.NewItem = {...this.NewItem, [key]: value};
        },

        checkForm() {
            if (this.selectedDictIsGuMain) {
                this.reassignGuMain()
                return
            }
            this.$v.NewItem.$touch();
            if (!this.$v.NewItem.$error) {
                this.saveOrUpdate()
            }
        },

        async confirmDeletion() {
            try {
                const confirmation = await this.$bvModal.msgBoxConfirm(
                    'Подтверждаете удаление?',
                    {
                        title: 'Подтверждение',
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Удалить',
                        cancelTitle: 'Отмена',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    })

                if (confirmation) {
                    const id = this.NewItem.id
                    await this.softDelete(id)
                    this.makeToast('Удалено', 'Сообщение', 'success')
                    this.ShowModal = false;
                    this.cleanItem();
                    await this.loadDirectory();
                }
            } catch (error) {
                this.makeToast('Не удалось совершить удаление', 'Ошибка', 'danger')
                console.error(error.toString())
            }
        },

        // софт-Удаление: доступно для любого справочника с колонкой isDeleted (см. activeDictSupportsSoftDelete)
        async softDelete(id) {
            const response = await fetch(`${this.activeDict.url}${this.activeDict.tableName}/soft-delete/${id}`, { method: 'DELETE' })
            if (!response.ok) {
                throw new Error('')
            }
        },

        makeToast(message, title, variant) {
            this.$bvToast.toast(message, {
                title: title,
                variant: variant,
                solid: true
            });
        },

        getDictItemById: function (ParentId) {
            for (const value of this.activeDictItems) {
                if (ParentId === value.id) {
                    return value.name_ru ? value.name_ru : value.nameRu
                }
            }
            return null;
        },

        selectDict: function (item) {
            this.activeDict = item;
            this.selectedDict = item.tableName
            this.checkEdit();
            this.tableFields = [...JSON.parse(JSON.stringify(this.activeDict.cols))];
            this.cleanItem();
            this.filter = ''
            this.filterParams = {};
            this.asyncSelectOptions = {};
            for (const iterator of item.cols) {
                if (iterator.type === 'asyncSelect' || iterator.type === 'select-async-multiple') {
                    this.asyncSelectOptions[iterator.key] = []
                }
            }
            if (item.filters) {
                for (const iterator of item.filters) {
                    this.asyncSelectOptions[iterator.key] = []
                }
            }
            this.select = [];
            this.currentPage = 1
            if (item.tableName === 'gu_main') {
                this.loadGuMainDirectory(this.regions[0].code, null)
                this.setSelectedRegionResettingAbp(this.regions[0])
            }
            else {
                this.loadDirectory()
            }
            this.resetModeTree();
        },

        handlePageChange(page) {
            this.currentPage = page
        },


        handleObjectInput(key, value, objectKey) {
            this.NewItem[key] = value[objectKey]
        },

        async loadSelects(key, query, selectsUrl) {
            const response = await fetch(selectsUrl + query)
            if (response.ok) {
                const res = await response.json()
                const items = res.items ? res.items : res

                // Labelling
                if (this.selectedDict === 'reasons_apps') {
                    items.forEach(item => {
                        item.label = `${item.form} (${item.code})`
                        item.shortLabel = `${item.form} (${item.code})`
                    })
                } else {
                    const column = this.activeDict.cols.find(item => item.key === key)
                    if (column.labelBy) {
                        items.map(item => this.assignLabel(item, column.labelBy))
                    } else {
                        items.map(item => {
                            const nameRu = item.nameRu ? item.nameRu : item.name_ru
                            const code = item.code ? item.code : item.fullCode
                            item.label = `${code} - ${nameRu}`
                            item.shortLabel = code
                            return item
                        })
                    }
                }

                if (this.asyncSelectOptions[key] === undefined)
                    this.asyncSelectOptions[key] = []
                this.asyncSelectOptions[key] = items
                this.asyncSelectOptions = JSON.parse(JSON.stringify(this.asyncSelectOptions))
            }
        },

        handleLoadSelects: debounce(async function(key, query, selectsUrl, loadOnce = false) {
            if (!loadOnce) {
                await this.loadSelects(key, query, selectsUrl)
            }
        }, 300),

        async loadAsyncSelectChoice() {
            for (const col of this.activeDict.cols) {
                if (col.loadOnce) {
                    let value = this.NewItem[col.key]
                    if (this.selectedDict === 'appointment') {
                        value = this.NewItem[col.key].module
                    }
                    let option
                    if (this.selectedDict === 'ebk_func_types') {
                        option = this.asyncSelectOptions[col.key].find(it => it.id === value)
                    } else if (this.selectedDict === 'ebk_doh_distribution') {
                        option = this.asyncSelectOptions[col.key].find(it => it.full_code === value)
                    } else if (this.selectedDict === 'reasons_apps') {
                        option = this.asyncSelectOptions[col.key].filter(it => value.includes(it.code))
                    } else {
                        option = cloneDeep(
                            // TODO: only support objs, not primitive types. Make compatible for both
                            this.asyncSelectOptions[col.key].find(it => it[col.key][col.trackBy] === value)
                        )
                    }
                    this.NewItem[col.key] = option
                }
                else if (col.type === 'select-async-multiple') {
                    const chosenItems = []
                    for (const item of this.NewItem[col.key]) {
                        const response = await fetch(col.selectsUrl + item)
                        if (response.ok) {
                            const data = await response.json()
                            const loadedItem = data.items ? data.items[0] : data
                            const nameRu = loadedItem.nameRu ? loadedItem.nameRu : loadedItem.name_ru
                            const code = loadedItem.code ? loadedItem.code : loadedItem.fullCode
                            loadedItem.label = `${code} - ${nameRu}`
                            loadedItem.shortLabel = code
                            chosenItems.push(loadedItem)
                        }
                    }
                    this.NewItem[col.key] = chosenItems
                }
                else if (this.activeDict.tableName === 'bip_object_directions') {
                    const response = await fetch(col.selectsUrl)
                    if (response.ok) {
                        const items = await response.json()
                        const item = items.find(it => it.code === this.NewItem[col.key])

                        const nameRu = item.nameRu ? item.nameRu : item.name_ru
                        const code = item.code ? item.code : item.fullCode
                        item.label = `${code} - ${nameRu}`

                        this.NewItem[col.key] = item
                    }
                }
                else if (col.key === 'statKato') {
                    if (this.NewItem.statKato) {
                        const code = this.NewItem.statKato.code
                        const nameRu = this.NewItem.statKato.name_ru
                        this.NewItem.statKato.label = `${code} - ${nameRu}`
                    }
                }
                else if (col.trackBy) {
                    let query = this.NewItem[col.key]
                    let url = col.selectsUrl
                    // for objects
                    if (col.key === 'budgetLevelId') {
                        if (this.NewItem[col.key]) {
                            url += '/pages?search-text='
                            query = this.NewItem[col.key]?.code
                        } else {
                            return
                        }
                    }
                    const response = await fetch(url + query)
                    if (response.ok) {
                        const data = (await response.json())
                        const item = data.items ? data.items[0] : data[0] ? data[0] : data

                        if (col.labelBy) {
                            this.assignLabel(item, col.labelBy)
                        } else {
                            if (col.key === 'budgetLevelId') {
                                item.label = `${item.id} - ${item.name_ru}`
                            } else {
                                const nameRu = item.nameRu ? item.nameRu : item.name_ru
                                const code = item.code ? item.code : item.fullCode
                                item.label = `${code} - ${nameRu}`
                            }
                        }

                        this.NewItem[col.key] = item
                    }
                }
            }
        },

        handleFilterParamsInput(key, value) {
            this.filterParams[key] = value
            if (value.label === '-') {
                delete this.filterParams[key]
            }
            this.loadDirectory()
        },

        filterGuMainItemsBy(option) {
            switch (option) {
                case this.filterOptions[0]:
                    this.activeDictItems = this.allDictItems
                    return;
                case this.filterOptions[1]:
                    this.activeDictItems = this.allDictItems.filter(item => item.main === 'O')
                    return;
                case this.filterOptions[2]:
                    let filteredItems = []
                    let temp = []
                    let includeFlag = true
                    let abp = this.allDictItems[0].abp_owner
                    this.allDictItems.forEach(item => {
                        if (item.abp_owner === abp) {
                            if (includeFlag)
                                temp.push(item)
                            if (item.main === 'O') {
                                includeFlag = false
                                temp = []
                            }
                        } else {
                            abp = item.abp_owner
                            filteredItems = filteredItems.concat(temp)
                            includeFlag = true
                            temp = []
                            if (item.main === 'O') {
                                includeFlag = false
                            } else {
                                temp.push(item)
                            }
                        }
                    });
                    filteredItems = filteredItems.concat(temp)
                    this.activeDictItems = filteredItems
                    return;
                default:
                    return;
            }
        },

        async loadDictItems() {
            this.loading = true;
            try {
                const responses = await Promise.all([
                    fetch('/api/stat-dict/industry'),
                    fetch('/api/guide/modules/data')
                ]);

                const [statIndustryResponse, sicModulesResponse] = responses;

                if (statIndustryResponse.ok) {
                    this.statIndustry = await statIndustryResponse.json();
                }

                if (sicModulesResponse.ok) {
                    this.sicModules = await sicModulesResponse.json();
                }

            } catch (error) {
                console.error('Error loading dictionary items:', error);
            } finally {
                this.loading = false;
            }
        },

        async loadDirectory() {
            this.loading = true;
            const params = {
                'items-per-page': `${this.perPage}`,
                'currentPage': `${this.currentPage}`,
                'search-text': this.filter
            };

            if (this.activeDictSupportsSoftDelete) {
                params['include-deleted'] = !this.excludeDeleted
            }

            let pages = '/pages?'

            for (const param in this.filterParams) {
                pages = '/filtered-pages?'
                const chosenFilter = this.filterParams[param]
                let trackBy
                for (let i = 0; i < this.activeDict.filters.length; i++) {
                    if (this.activeDict.filters[i].key === param) {
                        trackBy = this.activeDict.filters[i].trackBy
                    }
                }
                params[param] = chosenFilter[trackBy]
            }

            const queryString = new URLSearchParams(params).toString();

            try {
                const response = await fetch(`${this.activeDict.url}${this.activeDict.tableName}${pages}${queryString}`);
                const paginationList = await response.json();

                // Загрузка изначальных вариантов выбора
                for (const column of this.activeDict.cols) {
                    if (column.type === 'asyncSelect' || column.type === 'select-async-multiple') {
                        await this.loadSelects(column.key, '', column.selectsUrl)
                    }
                }

                this.activeDictItems = paginationList.items.map(item => {
                    item.open = !item.parent;
                    return item;
                });
                if (this.selectedDict === 'dict_ebk_doh') {
                    this.activeDictItems.forEach(it => {
                        it.budgetLevels = it.budgetLevels?.split(',')
                            .map(s => s.trim())
                            .filter(s => s !== '')
                            .map(Number) ?? null
                    })
                }
                if (this.selectedDict === 'ebk_doh_distribution') {
                    const column = this.activeDict.cols[0]
                    const response = await fetch(column.selectsUrl)
                    if (response.ok) {
                        const data = await response.json()
                        this.activeDictItems.forEach(item => {
                            const name = data.find(it => it.full_code === item.fullCode)?.name_ru || ''
                            item.name = name
                        })
                    }
                }
                if (this.selectedDict === 'appointment') {
                    this.activeDictItems.forEach(it => {
                        const moduleOption = this.asyncSelectOptions.module.find(option => option.code === it.module)
                        const operationOption = this.asyncSelectOptions.operation.find(option => option.code === it.operation)
                        it.module = moduleOption
                        it.operation = operationOption
                    })
                }
                if (this.selectedDict === 'reasons_apps') {
                    const column = this.activeDict.cols.find(it => it.key === 'appCodes')
                    const response = await fetch(column.selectsUrl)
                    if (response.ok) {
                        const data = await response.json()
                        this.activeDictItems.forEach(item => {
                            const name = data.find(it => it.code === item.fullCode)?.name_ru || ''
                            
                            const appCodesLabels = []
                            item.appCodes.forEach(code => {
                                const dict = data.find(it => it.code === code)
                                let label = code
                                if (dict) {
                                    label = `${dict.form} (${dict.code})`
                                }
                                appCodesLabels.push(label)
                            }) 
                            
                            item.appCodesLabels = appCodesLabels
                        })
                    }
                }

                this.select = true;
                this.itemCount = paginationList.itemCount
                this.currentPage = paginationList.page + 1
            } catch (error) {
                this.activeDictItems = []
                this.itemCount = 0
                console.error('An error occurred while loading dictionaries:', error);
            } finally {
                this.loading = false
            }
        },

        debouncedLoadDirectory: debounce(async function () {
            this.currentPage = 1
            await this.loadDirectory()
        }, 600),

        async loadGuMainDirectory(regionCode, abpCode) {
            this.loading = true;
            const params = abpCode
                ? {
                    'region-code': regionCode,
                    'abp-code': abpCode
                }
                : {
                    'region-code': regionCode
                };

            const queryString = new URLSearchParams(params).toString();

            try {
                const response = await fetch(`${this.activeDict.url}${this.activeDict.tableName}/region-abp?${queryString}`);
                const guItems = await response.json();
                let mainCode

                let isMoreThanOne = false
                let firstMainItem
                let abpCodeTemp = guItems[0].abp_owner
                guItems.map(item => {
                    // marking rows where multipe mains for one abp
                    if (abpCodeTemp !== item.abp_owner) {
                        abpCodeTemp = item.abp_owner
                        isMoreThanOne = false
                    }
                    if (item.main && isMoreThanOne) {
                        item._rowVariant = 'warning'
                        firstMainItem._rowVariant = 'warning'
                    } else if (item.main && !isMoreThanOne) {
                        isMoreThanOne = true
                        firstMainItem = item
                    }

                    mainCode = item.main ? item.code : mainCode
                    item.main = item.main ? 'O' : '-'
                    item.label = item.code + " " + item.name_ru
                    return item
                })
                this.selectedGuMain = mainCode
                this.guMain = mainCode
                this.guModalItems = guItems
                if (!this.ShowModal) {
                    this.allDictItems = guItems
                    this.filterGuMainItemsBy(this.selectedFilterOption)
                    this.itemCount = guItems.length
                }
            } catch (error) {
                this.activeDictItems = []
                this.itemCount = 0
                console.error('An error occurred while loading dictionaries:', error);
            } finally {
                this.loading = false
            }
        },

        async loadRegions() {
            this.loading = true;
            try {
                const response = await fetch('/api/dict/dict_budget_regions/order-by-code')

                if (response.ok) {
                    this.regions = await response.json();
                }

            } catch (error) {
                console.error('Error loading regions:', error);
            } finally {
                this.loading = false;
            }
        },

        async loadAbpItems(regionCode) {
            this.loading = true;
            try {
                const response = await fetch(`/api/dict/ebk_func_types/region-code/${regionCode}`)

                if (response.ok) {
                    const result = await response.json();
                    result.unshift({abp: '', name_ru: ''})
                    this.abpModalItems = result
                    if (!this.ShowModal)
                        this.abpItems = result
                }

            } catch (error) {
                console.error('Error loading abp items:', error);
            } finally {
                this.loading = false;
            }
        },

        downloadRep() {
            const dataToExcel = {
                url: this.activeDict.url,
                table_name: this.activeDict.tableName,
                name: this.activeDict.name
            };
            Ax(
                {
                    url: '/api-py/download_dict/',
                    method: 'POST',
                    responseType: 'blob',
                    data: dataToExcel
                },
                (data) => {
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.activeDict.name + '.xls');// or any other extension
                    document.body.appendChild(link);
                    link.click();
                },
                (error) => {
                    this.makeToast('danger', 'Ошибка запроса downloadRep()', error.toString());
                }
            );
        },

        async save() {
            try {
                this.loading = true
                this.hasUserSub()
                const body = this.convertObjectTypeFields(JSON.parse(JSON.stringify(this.NewItem)))
                const response = await fetch(this.activeDict.url + this.activeDict.tableName, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body)
                });
                if (response.ok) {
                    this.ShowModal = false;
                    this.makeToast('Элемент сохранен', 'Сообщение', 'success');
                    this.cleanItem();
                    await this.loadDirectory();
                } else {
                    let text = 'Извините, произошла ошибка на сервере или некорректно заполнены поля.'
                    const errorResponse = await response.json()
                    const key = errorResponse.key
                    let message = null
                    try {
                        message = errorResponse?.args[0]?.value[0]
                        const temp = errorResponse?.args[0]?.value
                        if (temp) {
                            message = temp
                        }
                    } catch (error) {}
                    if (key) {
                        text = key
                    }
                    if (message) {
                        text = message
                    }
                    this.makeToast(text, 'Ошибка сохранения', 'danger');
                    throw new Error('Network response was not ok');
                }
            } catch (error) {
                console.error('There was a problem with the fetch operation:', error);
            } finally {
                this.loading = false
            }
        },

        async reassignGuMain() {
            this.loading = true;
            try {
                const requests = []

                this.allDictItems.forEach(item => {
                    if (item.main === 'O' && item.code !== this.selectedGuMain) {
                        requests.push(
                            fetch(`/api/dict/gu_main?gu-code=${item.code}`, {
                                method: 'DELETE'
                            })
                        )
                    } else if (item.main === 'O' && item.code === this.selectedGuMain) {
                    } else if (item.code === this.selectedGuMain) {
                        requests.push(
                            fetch(`/api/dict/gu_main?gu-code=${this.selectedGuMain}`, {
                                method: 'POST'
                            })
                        )
                    }
                })

                const responses = await Promise.all(requests);

                const [saveResponse] = responses;

                if (saveResponse.ok) {
                    this.makeToast('Элемент сохранен', 'Сообщение', 'success');
                }
            } catch (error) {
                this.makeToast('danger', 'Ошибка запроса', error.toString());
            } finally {
                this.ShowModal = false;
                this.selectedGuMain = null
                this.guMain = null
                this.guModalItems = []
                this.cleanItem();
                this.selectedRegion = this.selectedModalRegion
                this.selectedAbp = this.selectedModalAbp
                this.setSelectedAbp(this.selectedModalAbp)
                this.selectedModalRegion = null
                this.selectedModalAbp = null
                this.loading = false;
            }
        },

        addItem: function () {
            this.mode = 'ADD'
            this.cleanItem();
            this.setDefaults();
            this.ShowModal = true;
        },

        cleanItem: function () {
            this.NewItem = {};
        },

        setDefaults: function () {
            const tempItem = {}
            this.activeDict.cols.forEach(column => {
                const isNullOrUndefined = column.default == null
                if (!isNullOrUndefined) {
                    tempItem[column.key] = column.default
                }
            })
            this.NewItem = tempItem
        },

        millisToDate: function (millis) {
            if (!millis) {
                return '';
            }

            if (typeof millis === 'string') {
                return millis
            }

            let year
            let month
            let day
            if (Array.isArray(millis)) {
                year = millis[0]
                month = millis[1]
                day = millis[2]
            } else {
                const date = new Date(millis);
                year = date.getFullYear();
                month = date.getMonth() + 1;
                day = date.getDate();
            }

            if (month.toString().length === 1) {
                month = '0' + month;
            }
            if (day.toString().length === 1) {
                day = '0' + day;
            }

            return year + '-' + month + '-' + day;
        },

        editItem: function () {
            if (this.selectedDictIsGuMain) {
                this.ShowModal = true
                return
            }

            if (this.NewItem.id) {
                this.ShowModal = true;
                this.mode = 'EDIT'
            } else {
                this.makeToast(
                    'Элемент справочника не выбран',
                    'Ошибка редактирования!'
                );
            }
        },

        async updateDictItem() {
            if (dictUpdateIncludeUsername.includes(this.selectedDict)) {
                this.hasUserSub()
            }
            const url = this.getUrl()
            const headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };
            const body = this.convertObjectTypeFields(JSON.parse(JSON.stringify(this.NewItem)))
            const response = await fetch(url, {
                headers,
                method: 'PUT',
                body: JSON.stringify(body)
            });
            if (response.ok) {
                this.ShowModal = false;
                this.cleanItem();
                await this.loadDirectory();
            } else {
                let text = 'Извините, произошла ошибка на сервере или некорректно заполнены поля.'
                const errorResponse = await response.json()
                const key = errorResponse.key
                let message = null
                try {
                    message = errorResponse?.args[0]?.value[0]
                    const temp = errorResponse?.args[0]?.value
                    if (temp) {
                        message = temp
                    }
                } catch (error) {}
                if (key) {
                    text = key
                }
                if (message) {
                    text = message
                }
                this.makeToast(text, 'Ошибка сохранения', 'danger');
            }
        },

        getUrl() {
            if (this.NewItem.resource === 'dict') {
                return `${this.activeDict.url}dicts`
            }
            const customUrl = ['enstru']
            if (customUrl.includes(this.selectedDict)) {
                return `${this.activeDict.url}${this.activeDict.tableName}/edit-custom-names`
            }
            return `${this.activeDict.url}${this.activeDict.tableName}`
        },

        assignLabel(item, labels) {
            let label = ''
            labels.forEach((columnName, index) => {
                if (index === 0) {
                    label += item[columnName]
                } else {
                    label += (' - ' + item[columnName])
                }
            })
            item.label = label
            return item
        },

        saveOrUpdate: function () {
            if (this.mode === 'ADD') {
                this.save()
            } else if (this.mode === 'EDIT') {
                this.updateDictItem()
            }
        },

        convertObjectTypeFields: function (object) {
            // Специальные ковертирования
            const customConverter = ['enstru']
            if (customConverter.includes(this.selectedDict)) {
                return {
                    id: object.id,
                    customNameRu: object.customNameRu,
                    customNameKz: object.customNameKz
                }
            }

            // Обобщенное конвертирования
            const cols = this.activeDict.cols
            for (const col of cols) {
                if (col.displayOnly) {
                    delete object[col.key]
                }

                switch (col.type) {
                    case 'select': {
                        if (object[col.key]) {
                            if (typeof object[col.key] === 'object') {
                                object[col.key] = object[col.key]['value']
                            }
                        }
                        break
                    }
                    case 'asyncSelect': {
                        if (col.key === 'statKato') {
                            // no opt.
                        } else if (col.trackBy && object[col.key]) {
                            object[col.key] = object[col.key][col.trackBy]
                        }
                        break
                    }
                    case 'select-multiple': {
                        if (this.selectedDict === 'dict_ebk_doh') {
                            object[col.key] = object[col.key].sort().join(', ')
                        }
                        break
                    }
                    case 'select-async-multiple': {
                        object[col.key] = object[col.key]?.map(item => item[col.trackBy])
                        break
                    }
                    case 'switch': {
                        if (this.selectedDict === 'gu' && col.key === 'orgAttribute') {
                            if (object[col.key]) {
                                object[col.key] = '1'
                            } else {
                                object[col.key] = null
                            }
                        }
                        else if (!object[col.key]) {
                            object[col.key] = false
                        }
                        break
                    }
                    default:
                        break
                }
            }
            return object
        },

        hasUserSub: function () {
            const hasUserName = this.activeDict.cols?.find(col => col.key === 'userName') !== undefined;
            if (hasUserName) {
                this.NewItem.userName = this.userSub
            }
        },

        setSelectedModalRegionResettingAbp(value) {
            this.selectedModalAbp = null
            this.loadAbpItems(value.code)
        },

        setSelectedRegionResettingAbp(value) {
            this.selectedAbp = null
            this.loadAbpItems(value.code)
            this.loadGuMainDirectory(value.code, null)
        },

        setSelectedRegion(value) {
            this.loadAbpItems(value.code)
            this.loadGuMainDirectory(value.code, null)
        },

        setSelectedAbp(value) {
            this.loadGuMainDirectory(this.selectedRegion.code, value.abp)
        },

        async updateDict() {
            // Сначала загрузить изменения и показать предпросмотр (ГУ, ЭКР и др. с integrationDictApiCode)
            if (this.integrationDictApiCode) {
                await this.loadDictChanges();
            } else {
                await this.executeUpdate();
            }
        },

        async loadDictChanges() {
            this.loadingChanges = true;
            this.updatePreviewError = null;
            this.updatePreviewStats = null;
            this.showUpdatePreviewModal = true;

            try {
                const code = this.integrationDictApiCode;
                if (!code) {
                    throw new Error('Справочник не поддерживает предпросмотр изменений');
                }
                const response = await fetch(`/api/integration/dict/changes_statistic/${code}`);

                if (!response.ok) {
                    throw new Error(`Ошибка загрузки изменений: ${response.status} ${response.statusText}`);
                }

                const data = await response.json();

                // API возвращает статистику в формате:
                // { inserted: number, deleted: number, updated: number, empty: boolean }
                const stats = {
                    total: (data.inserted || 0) + (data.deleted || 0) + (data.updated || 0),
                    insertCount: data.inserted || 0,
                    updateCount: data.updated || 0,
                    deleteCount: data.deleted || 0
                };

                this.updatePreviewStats = stats;
            } catch (error) {
                console.error('Ошибка загрузки изменений:', error);
                this.updatePreviewError = error.message || 'Не удалось загрузить изменения';
            } finally {
                this.loadingChanges = false;
            }
        },

        async downloadPreviewChangesExcel() {
            const code = this.integrationDictApiCode;
            if (!code) {
                return;
            }

            try {
                const url = `/api/integration/dict/changes/${code}/export`;
                const response = await fetch(url);
                if (!response.ok) {
                    const text = await response.text();
                    console.error('Скачивание Excel экспорта изменений:', response.status, response.statusText, text);
                    this.makeToast(`Не удалось скачать файл. Ответ сервера: ${response.status} ${response.statusText}`, 'Ошибка', 'danger');
                    return;
                }
                const blob = await response.blob();
                const disposition = response.headers.get('Content-Disposition');
                const fileNameMatch = disposition && disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                const defaultName = `${code}_changes_export.xlsx`;
                const fileName = fileNameMatch ? fileNameMatch[1].replace(/['"]/g, '').trim() : defaultName;
                const a = document.createElement('a');
                a.href = URL.createObjectURL(blob);
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(a.href);

                this.makeToast('Файл предпросмотра изменений скачан.', 'Сообщение', 'success');
            } catch (error) {
                console.error('Ошибка скачивания Excel для предпросмотра:', error);
                this.makeToast(error.message || 'Не удалось скачать Excel файл.', 'Ошибка', 'danger');
            }
        },

        async confirmUpdate() {
            // Проверить, есть ли изменения для применения
            if (this.updatePreviewStats && this.updatePreviewStats.total === 0) {
                this.makeToast('Изменений не обнаружено. Обновление не требуется.', 'Информация', 'info');
                this.resetUpdatePreview();
                return;
            }

            // Закрыть модальное окно предпросмотра
            this.showUpdatePreviewModal = false;

            // Выполнить обновление
            await this.executeUpdate();
        },

        cancelUpdate() {
            this.resetUpdatePreview();
        },

        resetUpdatePreview() {
            this.showUpdatePreviewModal = false;
            this.updatePreviewError = null;
            this.updatePreviewStats = null;
            this.pendingChanges = null;
            this.loadingChanges = false;
            this.showUpdateDetails = false;
        },

        toggleUpdateDetails() {
            this.showUpdateDetails = !this.showUpdateDetails;
        },

        async executeUpdate() {
            this.loading = true;
            try {
                const response = await fetch(this.activeDict.updateUrl, {
                    method: 'PUT'
                });
                if (response.ok) {
                    this.makeToast('Справочник успешно обновлен', 'Сообщение', 'success');

                    // Обновить таблицу справочника
                    await this.loadDirectory();

                    // Обновить журнал загрузок после успешного обновления
                    if (this.shouldShowTabs) {
                        // Сбросить на первую страницу журнала, чтобы увидеть новую запись
                        this.uploadLogCurrentPage = 1;

                        // Добавить небольшую задержку, чтобы бэкенд успел создать запись в журнале
                        await new Promise(resolve => setTimeout(resolve, 500));

                        // Загрузить журнал загрузок
                        // await this.loadUploadLog();

                        // Если запись не появилась сразу, попробовать еще раз через секунду
                        // setTimeout(async () => {
                        //     await this.loadUploadLog();
                        // }, 1000);
                    }
                } else {
                    // Улучшенная обработка ошибок - показать детали
                    let errorMessage = 'Ошибка обновления';
                    try {
                        const errorText = await response.text();
                        if (errorText) {
                            try {
                                const errorJson = JSON.parse(errorText);
                                errorMessage = errorJson.message || errorJson.error || errorMessage;
                            } catch (e) {
                                errorMessage = errorText.length > 100 ? errorText.substring(0, 100) + '...' : errorText;
                            }
                        }
                    } catch (e) {
                        errorMessage = `Ошибка обновления: ${response.status} ${response.statusText}`;
                    }
                    this.makeToast(errorMessage, 'Ошибка', 'danger');
                }
            } catch (error) {
                this.makeToast(`Ошибка обновления: ${error.message}`, 'Ошибка', 'danger');
            } finally {
                this.loading = false;
            }
        },

        formatUploadLogItems(items) {
            if (!Array.isArray(items)) {
                return []
            }
            return items.map(item => {
                // Обработка нового формата details (объект с summary и changesContent)
                let detailsSummary = null
                let hasChangesContent = false
                let rawDetails = null

                if (item.details) {
                    if (typeof item.details === 'object' && item.details.summary) {
                        // Новый формат: { summary: {...}, changesContent: [...] }
                        detailsSummary = item.details.summary
                        hasChangesContent = !!(item.details.changesContent && item.details.changesContent.length > 0)
                        rawDetails = item.details
                    } else if (typeof item.details === 'string') {
                        // Старый формат: строка
                        rawDetails = item.details
                    }
                }

                return {
                    id: item.id || item.loadId || '',
                    tableName: item.tableName || item.table_name || 'Visual_gu',
                    loadDateTime: this.formatDateTime(item.finishDateTime || item.loadDateTime || item.load_date_time || item.dateTime),
                    loadStatus: this.formatLoadStatus(item.status || item.loadStatus || item.load_status),
                    user: this.formatUser(item.user || item.userName || item.username),
                    details: rawDetails ? (typeof rawDetails === 'string' ? rawDetails : '') : '',
                    detailsSummary: detailsSummary,
                    hasChangesContent: hasChangesContent,
                    rawDetails: rawDetails, // Сохраняем полный объект details для модального окна
                    launchType: this.formatLaunchType(item.runType || item.launchType || item.launch_type || item.type)
                }
            })
        },

        formatDateTime(dateTime) {
            if (!dateTime) return ''
            if (typeof dateTime === 'number') {
                const date = new Date(dateTime)
                return this.formatDateToDDMMYYYYHHMMSS(date)
            }
            if (typeof dateTime === 'string') {
                const date = new Date(dateTime)
                return this.formatDateToDDMMYYYYHHMMSS(date)
            }
            return dateTime.toString()
        },

        formatDateToDDMMYYYYHHMMSS(date) {
            if (!date || isNaN(date.getTime())) return ''
            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')
            const seconds = String(date.getSeconds()).padStart(2, '0')
            return `${day}.${month}.${year}, ${hours}:${minutes}:${seconds}`
        },

        formatLoadStatus(status) {
            if (!status) return ''
            const statusLower = String(status).toLowerCase()
            if (statusLower.includes('ошибка') || statusLower.includes('error')) {
                return 'Ошибка'
            }
            if (statusLower.includes('не требуется') || statusLower.includes('not required')) {
                return 'Обновление не требуется'
            }
            return 'Данные обновлены'
        },

        formatUser(user) {
            if (!user || String(user).toLowerCase().includes('auto') || String(user).toLowerCase().includes('авто')) {
                return 'Автозагрузка'
            }
            return user
        },

        formatDetails(details) {
            if (!details) return ''
            return details
        },

        formatLaunchType(type) {
            if (!type) return ''
            const typeLower = String(type).toLowerCase()
            if (typeLower.includes('auto') || typeLower.includes('авто')) {
                return 'Авто'
            }
            return 'Ручное'
        },

        showLogDetails(item) {
            this.logDetailsData = null
            this.logDetailsLoading = false

            if (item.rawDetails && item.rawDetails.changesContent) {
                // Если данные уже есть в объекте
                this.logDetailsData = {
                    detailsSummary: item.rawDetails.summary,
                    changesContent: item.rawDetails.changesContent,
                    truncated: item.rawDetails.truncated || false,
                    totalChangesCount: item.rawDetails.totalChangesCount || item.rawDetails.changesContent.length,
                    error: item.rawDetails.error || null
                }
                this.showLogDetailsModal = true
            } else if (item.id) {
                // Если нужно загрузить детали через отдельный эндпоинт
                this.loadLogDetails(item.id)
            } else {
                // Fallback на старый формат
                this.logDetailsData = {
                    error: item.details || 'Детализация недоступна'
                }
                this.showLogDetailsModal = true
            }
        },

        async loadLogDetails(logId) {
            this.logDetailsLoading = true
            this.showLogDetailsModal = true

            const code = this.integrationDictApiCode
            if (!code) {
                this.logDetailsData = {
                    error: 'Не удалось определить справочник для загрузки деталей'
                }
                this.logDetailsLoading = false
                return
            }

            try {
                const response = await fetch(`/api/integration/dict/log/${code}/${logId}/details`)
                if (response.ok) {
                    const data = await response.json()
                    this.logDetailsData = {
                        detailsSummary: data.summary,
                        changesContent: data.changesContent || [],
                        truncated: data.truncated || false,
                        totalChangesCount: data.totalChangesCount || (data.changesContent ? data.changesContent.length : 0),
                        error: data.error || null
                    }
                } else {
                    this.logDetailsData = {
                        error: `Ошибка загрузки деталей: ${response.status} ${response.statusText}`
                    }
                }
            } catch (error) {
                console.error('Ошибка загрузки деталей журнала:', error)
                this.logDetailsData = {
                    error: `Ошибка загрузки деталей: ${error.message}`
                }
            } finally {
                this.logDetailsLoading = false
            }
        },

        resetLogDetails() {
            this.showLogDetailsModal = false
            this.logDetailsData = null
            this.logDetailsLoading = false
        },

        formatChangesContent(changesContent) {
            if (!Array.isArray(changesContent)) {
                return []
            }

            const result = []

            changesContent.forEach((change, index) => {
                const changeType = (change.changeType || '').toUpperCase()

                if (changeType === 'UPDATE' && change.changes) {
                    // Для UPDATE разворачиваем changes в отдельные строки
                    Object.keys(change.changes).forEach(field => {
                        const changeValue = change.changes[field]
                        result.push({
                            changeType: changeType,
                            code: change.values?.code || change.values?.id || '',
                            field: field,
                            oldValue: changeValue.oldValue,
                            newValue: changeValue.newValue
                        })
                    })
                } else if (changeType === 'INSERT') {
                    // Для INSERT показываем значения из values
                    if (change.values && typeof change.values === 'object') {
                        Object.keys(change.values).forEach(field => {
                            result.push({
                                changeType: changeType,
                                code: change.values?.code || change.values?.id || '',
                                field: field,
                                oldValue: '',
                                newValue: change.values[field]
                            })
                        })
                    } else {
                        result.push({
                            changeType: changeType,
                            code: change.values?.code || change.values?.id || '',
                            field: 'Новая запись',
                            oldValue: '',
                            newValue: change.values ? JSON.stringify(change.values) : ''
                        })
                    }
                } else if (changeType === 'DELETE') {
                    // Для DELETE показываем значения из values
                    if (change.values && typeof change.values === 'object') {
                        Object.keys(change.values).forEach(field => {
                            result.push({
                                changeType: changeType,
                                code: change.values?.code || change.values?.id || '',
                                field: field,
                                oldValue: change.values[field],
                                newValue: ''
                            })
                        })
                    } else {
                        result.push({
                            changeType: changeType,
                            code: change.values?.code || change.values?.id || '',
                            field: 'Удаленная запись',
                            oldValue: change.values ? JSON.stringify(change.values) : '',
                            newValue: ''
                        })
                    }
                }
            })

            return result
        },

        formatChangeType(changeType) {
            const type = (changeType || '').toUpperCase()
            const map = {
                'INSERT': 'Добавление',
                'UPDATE': 'Обновление',
                'DELETE': 'Удаление'
            }
            return map[type] || changeType
        },

        getChangeTypeClass(changeType) {
            const type = (changeType || '').toUpperCase()
            if (type === 'INSERT') return 'text-success'
            if (type === 'UPDATE') return 'text-warning'
            if (type === 'DELETE') return 'text-danger'
            return ''
        },

        formatChangeValue(value) {
            if (value === null || value === undefined) {
                return '<пусто>'
            }
            if (typeof value === 'object') {
                return JSON.stringify(value)
            }
            if (typeof value === 'number' && value > 1000000000000) {
                // Вероятно, это timestamp
                const date = new Date(value)
                if (!isNaN(date.getTime())) {
                    return this.formatDateToDDMMYYYYHHMMSS(date)
                }
            }
            return String(value)
        },

        handleUploadLogPageChange(page) {
            this.uploadLogCurrentPage = page
            // this.loadUploadLog()
        },

        getStatusStyle(status) {
            if (status === 'Ошибка') {
                return 'color: #dc3545; font-weight: 500;'
            }
            if (status === 'Обновление не требуется') {
                return 'color: #6c757d;'
            }
            return 'color: #28a745; font-weight: 500;'
        }
    }
};
</script>
<style scoped>
.input {
    width: 100%;
    max-width: 100%;
    height: 35px;
}

.tr {
    white-space: nowrap;
}

.modal-body {
    color: #000;
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.float-left {
    color: rgb(218, 24, 40);
}

.search-nav {
    width: 700px;
}

.small-padding {
    padding: 5px;
}

.tab-button {
    font-weight: 500;
    font-size: 14px;
    color: #495057;
    transition: all 0.2s;
    user-select: none;
}

.tab-button:hover {
    background-color: #e9ecef !important;
}

/* Стили для модального окна предпросмотра изменений */
.update-preview-modal .modal-dialog {
    max-width: 720px;
}

.update-preview-modal .modal-header {
    padding: 16px 24px;
    border-bottom: 1px solid #eef1f5;
}

.update-preview-modal .modal-title {
    font-size: 18px;
    font-weight: 500;
    color: #212529;
}

.update-preview-modal .close {
    font-size: 22px;
    opacity: 0.7;
}

.update-preview-modal .modal-body {
    padding: 16px 24px;
}

.update-preview-modal .modal-footer {
    border-top: 1px solid #eef1f5;
    padding: 12px 24px 16px;
    justify-content: center;
}

.update-preview-footer {
    display: flex;
    justify-content: center;
    gap: 12px;
    width: 100%;
}

.update-preview-download-link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    color: inherit;
}

.update-preview-download-link:hover {
    opacity: 0.85;
}

.update-preview-excel-icon {
    width: 21px;
    height: 20px;
    vertical-align: middle;
}

.update-preview-extension {
    font-size: 0.9em;
}

.update-preview-modal .modal-footer .btn {
    min-width: 140px;
    font-weight: 500;
    text-transform: uppercase;
    font-size: 14px;
    padding: 8px 22px;
    border-radius: 6px;
}

.update-preview-modal .modal-footer .btn-primary {
    background-color: #4f80ff;
    border-color: #4f80ff;
    box-shadow: 0 2px 4px rgba(79, 128, 255, 0.2);
}

.update-preview-modal .modal-footer .btn-primary:hover {
    background-color: #3f6fe6;
    border-color: #3f6fe6;
}

.update-preview-modal .modal-footer .btn-outline-secondary {
    color: #6c757d;
    border-color: #ced4da;
    background-color: #fff;
}

.update-preview-modal .modal-footer .btn-outline-secondary:hover {
    background-color: #f8f9fa;
    color: #495057;
}

/* Стили для карточек статистики предпросмотра изменений */
.preview-stats-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    margin-bottom: 12px;
}

.stat-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid #e7eaf0;
    background-color: #fff;
    transition: border-color 0.2s ease;
    cursor: pointer;
    user-select: none;
}

.stat-card:hover {
    border-color: #d3dbe6;
}

.stat-card-download {
    cursor: default;
    font-size: 13px;
}
.stat-card-download .update-preview-download-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: inherit;
}
.stat-card-download .update-preview-download-suffix {
    display: inline-flex;
    align-items: center;
    gap: 0;
}
.stat-card-download .update-preview-excel-icon {
    width: 18px;
    height: 17px;
    vertical-align: middle;
}
.stat-card-download .update-preview-extension {
    font-size: 0.85em;
}

.stat-label {
    font-size: 14px;
    font-weight: 400;
    color: #6c757d;
    flex: 1;
}

.stat-value {
    font-size: 18px;
    font-weight: 600;
    margin-right: 10px;
    min-width: 35px;
    text-align: right;
}

.stat-arrow {
    font-size: 22px;
    color: #5b7cff;
    font-weight: 400;
}

.stat-card-success .stat-label,
.stat-card-success .stat-value {
    color: #1f9d55;
}

.stat-card-danger .stat-label,
.stat-card-danger .stat-value {
    color: #e74c3c;
}

.stat-card-warning .stat-label,
.stat-card-warning .stat-value {
    color: #f0a500;
}

/* Сообщение подтверждения */
.confirmation-message {
    margin-top: 10px;
    text-align: center;
    padding: 10px 18px;
    border: 1px solid #ffa940;
    border-radius: 6px;
    background-color: #ffffff;
    color: #000000;
    font-size: 14px;
    font-weight: 400;
}

/* Анимация для появления таблицы деталей */
.slide-fade-enter-active {
    transition: all 0.3s ease;
}

.slide-fade-leave-active {
    transition: all 0.2s ease;
}

.slide-fade-enter {
    transform: translateY(-10px);
    opacity: 0;
}

.slide-fade-leave-to {
    transform: translateY(-10px);
    opacity: 0;
}

.tab-active {
    background-color: #EEF1F8 !important;
    color: #212529;
    font-weight: 600;
}
</style>